import gql from 'graphql-tag';

export const FrequentSearchCreateQuery = gql`
    query FrequentSearchCreateQuery {
        editorialSectionTree(EditorialBrand: GOODS4HUB) {
            id
            name
            Parent {
                id
            }
            goodClasses {
                id
                shortname
                shortnameIta
                localId
                name
                nameIta
            }
        }
    }
`;


